import {
  defaultLaunchQueryParams,
  launchQueryParamsSchema,
} from "@/pages/launch/schemata";
import {
  createFileRoute,
  redirect,
  stripSearchParams,
} from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/groups/$groupId/apps/$appId/launch/$renderMode/$targetDeviceType",
)({
  validateSearch: launchQueryParamsSchema,
  search: {
    // strip default values
    middlewares: [stripSearchParams(defaultLaunchQueryParams)],
  },
  beforeLoad: ({ params, search }) => {
    // group information does not matter for launching an app
    throw redirect({
      to: "/apps/$appId/launch/$renderMode/$targetDeviceType",
      params,
      search,
    });
  },
});
